/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { XHR } from './XHR'
import { AbstractFilterDevice } from '../model/AbstractFilterDevice'
import { Device } from '../model/Device'
import { DocIdentifier } from '../model/DocIdentifier'
import { FilterChainDevice } from '../model/FilterChainDevice'
import { IdWithRev } from '../model/IdWithRev'
import { ListOfIds } from '../model/ListOfIds'
import { PaginatedListDevice } from '../model/PaginatedListDevice'
import { TimingInfo } from '../model/TimingInfo'
import { AuthenticationProvider, NoAuthenticationProvider } from '../../icc-x-api/auth/AuthenticationProvider'
import { iccRestApiPath } from './IccRestApiPath'
import { ConflictResolutionRequest } from '../model/ConflictResolutionRequest'
import { ConflictResolutionResult } from '../model/ConflictResolutionResult'
import { ConflictResolutionStrategy } from '../model/ConflictResolutionStrategy'
import { MergeResult } from '../model/MergeResult'

export class IccDeviceApi {
  host: string
  headers: Array<XHR.Header>
  authenticationProvider: AuthenticationProvider
  fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>

  constructor(
    host: string,
    headers: any,
    authenticationProvider?: AuthenticationProvider,
    fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>
  ) {
    this.host = iccRestApiPath(host)
    this.headers = Object.keys(headers).map((k) => new XHR.Header(k, headers[k]))
    this.authenticationProvider = !!authenticationProvider ? authenticationProvider : new NoAuthenticationProvider()
    this.fetchImpl = fetchImpl
  }

  setHeaders(h: Array<XHR.Header>) {
    this.headers = h
  }

  handleError(e: XHR.XHRError): never {
    throw e
  }

  /**
   * Name, last name, date of birth, and gender are required. After creation of the device and obtaining the ID, you need to create an initial delegation.
   * @summary Create a device
   * @param body
   */
  async createDevice(body?: Device): Promise<Device> {
    const _url = this.host + `/device` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new Device(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * One of Name or Last name+First name, Nihii, and Public key are required.
   * @summary Create a device
   * @param body
   * @param groupId
   */
  async createDeviceInGroup(groupId: string, body?: Device): Promise<Device> {
    const _url = this.host + `/device/inGroup/${encodeURIComponent(String(groupId))}` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new Device(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns the id and _rev of created devices
   * @summary Create devices in bulk
   * @param body
   */
  createDevices(body?: Array<Device>): Promise<Array<IdWithRev>> {
    let _body = null
    _body = body

    const _url = this.host + `/device/batch` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new IdWithRev(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns the id and _rev of created devices
   * @summary Create devices in bulk
   * @param body
   */
  createDevices1(body?: Array<Device>): Promise<Array<IdWithRev>> {
    let _body = null
    _body = body

    const _url = this.host + `/device/bulk` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new IdWithRev(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Response contains the id/rev of deleted device.
   * @summary Delete device.
   * @param deviceId
   */
  async deleteDevice(deviceId: string): Promise<DocIdentifier> {
    let _body = null

    const _url = this.host + `/device/${encodeURIComponent(String(deviceId))}` + '?ts=' + new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('DELETE', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new DocIdentifier(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Response is an array containing the id/rev of deleted devices.
   * @summary Delete devices.
   * @param body
   */
  async deleteDevices(body?: ListOfIds): Promise<Array<DocIdentifier>> {
    const _url = this.host + `/device/delete/batch` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new DocIdentifier(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Deleting a device. Response is an array containing the id of deleted device.
   * @summary Delete a device
   * @param groupId
   * @param deviceIds
   */
  deleteDevicesInGroup(groupId: string, deviceIds: string): Promise<Array<DocIdentifier>> {
    let _body = null

    const _url =
      this.host + `/device/inGroup/${encodeURIComponent(String(groupId))}/${encodeURIComponent(String(deviceIds))}` + '?ts=' + new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('DELETE', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new DocIdentifier(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns a list of devices along with next start keys and Document ID. If the nextStartKey is Null it means that this is the last page.
   * @summary Filter devices for the current user (HcParty)
   * @param body
   * @param startDocumentId A device document ID
   * @param limit Number of rows
   * @param collectTiming if true, include server-side filter timing information in the response
   */
  filterDevicesBy(startDocumentId?: string, limit?: number, body?: FilterChainDevice, collectTiming?: false): Promise<PaginatedListDevice>
  filterDevicesBy(startDocumentId?: string, limit?: number, body?: FilterChainDevice, collectTiming?: true): Promise<PaginatedListDevice & TimingInfo>
  filterDevicesBy(startDocumentId?: string, limit?: number, body?: FilterChainDevice, collectTiming: boolean = false): Promise<PaginatedListDevice> {
    let _body = null
    _body = body

    const _url =
      this.host +
      `/device/filter` +
      '?ts=' +
      new Date().getTime() +
      (startDocumentId ? '&startDocumentId=' + encodeURIComponent(String(startDocumentId)) : '') +
      (limit ? '&limit=' + encodeURIComponent(String(limit)) : '')
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand(
      'POST',
      _url,
      headers,
      _body,
      this.fetchImpl,
      undefined,
      this.authenticationProvider.getAuthService(),
      undefined,
      false,
      collectTiming ? ['x-filter-timing-*'] : []
    )
      .then((doc) => Object.assign(new PaginatedListDevice(doc.body as JSON), collectTiming ? { responseHeaders: doc.responseHeaders } : {}))
      .catch((err) => this.handleError(err))
  }

  /**
   * It gets device administrative data.
   * @summary Get Device
   * @param deviceId
   */
  getDevice(deviceId: string): Promise<Device> {
    let _body = null

    const _url = this.host + `/device/${encodeURIComponent(String(deviceId))}` + '?ts=' + new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new Device(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * (key, value) of the map is as follows: (ID of the owner of the encrypted AES key, encrypted AES keys)
   * @summary Get the HcParty encrypted AES keys indexed by owner.
   * @param deviceId
   */
  getDeviceAesExchangeKeysForDelegate(
    deviceId: string
  ): Promise<{ [delegatorId: string]: { [delegatorPubKeyFingerprint: string]: { [delegatePubKeyFingerprint: string]: string } } }> {
    let _body = null

    const _url = this.host + `/device/${encodeURIComponent(String(deviceId))}/aesExchangeKeys` + '?ts=' + new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => JSON.parse(JSON.stringify(doc.body)))
      .catch((err) => this.handleError(err))
  }

  /**
   * It gets device administrative data.
   * @summary Get devices by id
   * @param body
   */
  getDevices(body?: ListOfIds): Promise<Array<Device>> {
    let _body = null
    _body = body

    const _url = this.host + `/device/byIds` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new Device(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * General information about the device
   * @summary Get devices by their IDs
   * @param body
   * @param groupId
   */
  getDevicesInGroup(groupId: string, body?: ListOfIds): Promise<Array<Device>> {
    let _body = null
    _body = body

    const _url = this.host + `/device/inGroup/${encodeURIComponent(String(groupId))}/byIds` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new Device(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Get ids of devices matching the provided filter for the current user (HcParty)
   * @param body
   * @param collectTiming add timing information to the response
   */
  matchDevicesBy(body?: AbstractFilterDevice, collectTiming?: false): Promise<Array<string>>
  matchDevicesBy(body?: AbstractFilterDevice, collectTiming?: true): Promise<Array<string> & TimingInfo>
  matchDevicesBy(body?: AbstractFilterDevice, collectTiming: boolean = false): Promise<Array<string>> {
    let _body = null
    _body = body

    const _url = this.host + `/device/match` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand(
      'POST',
      _url,
      headers,
      _body,
      this.fetchImpl,
      undefined,
      this.authenticationProvider.getAuthService(),
      undefined,
      false,
      collectTiming ? ['x-filter-timing-*'] : []
    )
      .then((doc) =>
        Object.assign(
          (doc.body as Array<JSON>).map((it) => JSON.parse(JSON.stringify(it))),
          collectTiming ? { responseHeaders: doc.responseHeaders } : {}
        )
      )
      .catch((err) => this.handleError(err))
  }

  /**
   * No particular return value. It's just a message.
   * @summary Modify a Device.
   * @param body
   * @param groupId
   */
  modifyDeviceInGroup(groupId: string, body?: Device): Promise<Device> {
    let _body = null
    _body = body

    const _url = this.host + `/device/inGroup/${encodeURIComponent(String(groupId))}` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new Device(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns the updated device
   * @summary Modify a device
   * @param body
   */
  updateDevice(body?: Device): Promise<Device> {
    let _body = null
    _body = body

    const _url = this.host + `/device` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new Device(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns the id and _rev of modified devices
   * @summary Modify devices in bulk
   * @param body
   */
  updateDevices(body?: Array<Device>): Promise<Array<IdWithRev>> {
    let _body = null
    _body = body

    const _url = this.host + `/device/batch` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new IdWithRev(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Returns the id and _rev of modified devices
   * @summary Modify devices in bulk
   * @param body
   */
  updateDevices1(body?: Array<Device>): Promise<Array<IdWithRev>> {
    let _body = null
    _body = body

    const _url = this.host + `/device/bulk` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new IdWithRev(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Retrieves the ids of all the devices that currently have conflicting revisions and therefore need to
   * be resolved.
   * @summary List the ids of the devices that have conflicts.
   * @return the ids of the devices with unresolved conflicts.
   */
  async getConflictingEntitiesIds(): Promise<Array<string>> {
    const _url = this.host + `/device/conflicts` + '?ts=' + new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => doc.body as Array<string>)
      .catch((err) => this.handleError(err))
  }

  /**
   * Retrieves all the conflicting revisions of the device with the given id (the current revision is not
   * included). The returned entities are still encrypted.
   * @summary Get the conflicting revisions of a device.
   * @param entityId the id of the device to retrieve the conflicts for.
   * @return the conflicting revisions of the device.
   */
  async getConflictsForEntity(entityId: string): Promise<Array<Device>> {
    const _url = this.host + `/device/conflicts/of?entityId=${encodeURIComponent(String(entityId))}` + '&ts=' + new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new Device(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Resolves a conflict by declaring which revision of the device should be kept as winner and which
   * conflicting revisions should be purged. The provided document must already be encrypted.
   * @summary Declare the winning revision of a conflicting device.
   * @param body the {@link ConflictResolutionRequest} carrying the winning revision and the conflicts to purge.
   * @return the {@link ConflictResolutionResult} with the saved winner and the conflicts that are still unresolved.
   */
  async declareConflictWinner(body: ConflictResolutionRequest<Device>): Promise<ConflictResolutionResult<Device>> {
    const _url = this.host + `/device/conflicts/winner` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new ConflictResolutionResult<Device>(doc.body, (x) => new Device(x)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Like {@link getConflictingEntitiesIds} but targets the entities of the group with the given id.
   * @summary List the ids of the devices that have conflicts, in the given group.
   * @param groupId the id of the group to look into.
   * @return the ids of the devices with unresolved conflicts in the group.
   */
  async getConflictingEntitiesIdsInGroup(groupId: string): Promise<Array<string>> {
    const _url = this.host + `/device/inGroup/${encodeURIComponent(String(groupId))}/conflicts` + '?ts=' + new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => doc.body as Array<string>)
      .catch((err) => this.handleError(err))
  }

  /**
   * Like {@link getConflictsForEntity} but targets the entity of the group with the given id.
   * @summary Get the conflicting revisions of a device, in the given group.
   * @param groupId the id of the group the device belongs to.
   * @param entityId the id of the device to retrieve the conflicts for.
   * @return the conflicting revisions of the device.
   */
  async getConflictsForEntityInGroup(groupId: string, entityId: string): Promise<Array<Device>> {
    const _url =
      this.host +
      `/device/inGroup/${encodeURIComponent(String(groupId))}/conflicts/of?entityId=${encodeURIComponent(String(entityId))}` +
      '&ts=' +
      new Date().getTime()
    let headers = this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new Device(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Like {@link declareConflictWinner} but targets the entity of the group with the given id.
   * @summary Declare the winning revision of a conflicting device, in the given group.
   * @param groupId the id of the group the device belongs to.
   * @param body the {@link ConflictResolutionRequest} carrying the winning revision and the conflicts to purge.
   * @return the {@link ConflictResolutionResult} with the saved winner and the conflicts that are still unresolved.
   */
  async declareConflictWinnerInGroup(groupId: string, body: ConflictResolutionRequest<Device>): Promise<ConflictResolutionResult<Device>> {
    const _url = this.host + `/device/inGroup/${encodeURIComponent(String(groupId))}/conflicts/winner` + '?ts=' + new Date().getTime()
    let headers = this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new ConflictResolutionResult<Device>(doc.body, (x) => new Device(x)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Automatically resolves the conflicting revisions of the devices with the given ids, according to the provided
   * {@link ConflictResolutionStrategy}.
   * @summary Automatically solve the conflicts of the devices with the given ids.
   * @param entityIds the ids of the devices to solve the conflicts for.
   * @param strategy the {@link ConflictResolutionStrategy} to use to resolve the conflicts. Defaults to `FullMergeability`.
   * @return the {@link MergeResult} of the conflict resolution for each requested entity.
   */
  async autoSolveConflicts(
    entityIds: Array<string>,
    strategy: ConflictResolutionStrategy = ConflictResolutionStrategy.FullMergeability
  ): Promise<Array<MergeResult>> {
    const _url = this.host + `/device/conflicts/solve?strategy=${encodeURIComponent(String(strategy))}` + '&ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, entityIds, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new MergeResult(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * Like {@link autoSolveConflicts} but targets the entities of the group with the given id.
   * @summary Automatically solve the conflicts of the devices with the given ids, in the given group.
   * @param groupId the id of the group to look into.
   * @param entityIds the ids of the devices to solve the conflicts for.
   * @param strategy the {@link ConflictResolutionStrategy} to use to resolve the conflicts. Defaults to `FullMergeability`.
   * @return the {@link MergeResult} of the conflict resolution for each requested entity.
   */
  async autoSolveConflictsInGroup(
    groupId: string,
    entityIds: Array<string>,
    strategy: ConflictResolutionStrategy = ConflictResolutionStrategy.FullMergeability
  ): Promise<Array<MergeResult>> {
    const _url =
      this.host +
      `/device/inGroup/${encodeURIComponent(String(groupId))}/conflicts/solve?strategy=${encodeURIComponent(String(strategy))}` +
      '&ts=' +
      new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, entityIds, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new MergeResult(it)))
      .catch((err) => this.handleError(err))
  }
}
